import {useCallback, useLayoutEffect, useState} from 'react';

import {findItemControl} from './DraggableChip';

const hasKeyboardFocus = (element: Element): boolean => {
  try {
    return element.matches(':focus-visible');
  } catch {
    return true;
  }
};

/**
 * Moving an item replaces or re-inserts its element, which drops focus. Returns a function that
 * takes an item id and puts focus on that item's control once the move has rendered, within the
 * question that has focus. It does nothing for a move made with the pointer.
 */
export const useRestoreItemFocus = (): ((itemId: string) => void) => {
  const [request, setRequest] = useState<{itemId: string; root: Element} | null>(null);

  useLayoutEffect(() => {
    if (!request) return;
    const wrapper = Array.from(request.root.querySelectorAll<HTMLElement>('[data-item-id]')).find(
      (element) => element.dataset.itemId === request.itemId
    );
    findItemControl(wrapper)?.focus();
  }, [request]);

  return useCallback((itemId: string) => {
    const focused = document.activeElement;
    if (!focused || !hasKeyboardFocus(focused)) return;
    const root = focused.closest('[data-dnd-context]');
    if (root) setRequest({itemId, root});
  }, []);
};
